import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RequireAuth = ({ children, permission }) => {
  const { user, loading, hasPermission } = useAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen bg-black flex items-center justify-center text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  if (permission && !hasPermission(permission)) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <h1 className="serif-italic gold-gradient-text text-4xl mb-3">Access denied</h1>
          <p className="text-zinc-400">Your role does not have the <code className="text-[#d4af37]">{permission}</code> permission. Ask the owner to grant it.</p>
        </div>
      </div>
    );
  }
  return children;
};

export default RequireAuth;
